import type { IconSvgObject } from './types';

const CircleArrowMoveDownRightIcon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.6314 12.525C14.1397 13.1552 15.1725 13.9359 14.9886 14.3065M14.9886 14.3065C15.091 14.6845 14.0911 15.4315 13.6292 16.0014M14.9886 14.3065C12.9059 14.3518 11.6315 14.0999 10.4014 12.875C9.12028 11.5993 8.90953 10.2054 9.01322 7.99683", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowMoveDownRightIcon;
